
import { Options, Provide, Vue } from "vue-property-decorator";
import { AdStore, Banner, measure, MediaEnum } from "@rtl/ui";

@Options({
  components: {
    Banner,
  },
})
export default class AdZone extends Vue {
  @Provide({ reactive: true })
  adStore: AdStore = {
    adoKeys: {
      [MediaEnum.MOBILE]: {
        masterId: "IOpFTDxEPXtUawVFG3pthwM7Mpa6BP4w7gqAe19gRXX.S7",
        zones: {
          m_special: "adoceangemhuzlpeolihkv",
        },
      },
      [MediaEnum.APP]: {
        masterId: "xOA7GB2eODzNRy3wtwPqPLUXfP_9Jwe3aPKYMAkmjrr.e7",
        zones: {
          app_special: "adoceangemhupkrhhreogb",
        },
      },
    },
    initialized: false,
    master: null,
    slaves: [],
    resetting: false,
  };

  handleChange(dimension: { width: number; height: number }) {
    if (
      this.$gtm &&
      this.$gtm.enabled() &&
      dimension.width > 1 &&
      dimension.height > 1
    ) {
      measure(
        {
          event_name: "ad_fullfilled",
          ad_width: dimension.width,
          ad_height: dimension.height,
        },
        { baseUrl: this.$store.getters.getEnv("RTL_URL"), gtm: this.$gtm }
      );
    }
  }
}
